import { useState } from "react";
import { useDispatch } from "react-redux";
import { Form, Select, Button, DatePicker, Row, Col, Spin } from "antd";
import isUndefined from "lodash/isUndefined";
import find from "lodash/find";
import map from "lodash/map";
import get from "lodash/get";
import set from "lodash/set";
import isNil from "lodash/isNil";
import dayjs from "dayjs";
import { getButtonDisabled } from "../../utilities/helpers";
import {
  fetchCompanyTemplates,
} from "../../redux/actions/templateActions";
import { BREAKDOWN_PERMISSION } from "../../constants";

const HeaderSelector = ({
  filter,
  config,
  form,
  setFilters,
  setConfig,
  getDetails,
  setSelectedShift,
  setDataSource,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const companies = get(config, "companies", [])
  .filter(company =>
    find(get(company, "feature_permissions", []), ['key', BREAKDOWN_PERMISSION])
  )
  .map(company => ({
    label: get(company, "name"),
    value: get(company, "id"),
  }));

  const disabledDate = (current) => {
    return current && current > dayjs().endOf("day");
  };

  const getCompanyTemplates = (type) => {
    setLoading(true);
    dispatch(fetchCompanyTemplates(get(filter, "company.id"), { type }))
      .then((result) => {
        setConfig({
          ...config,
          templates: result,
        });
        setFilters({
          ...filter,
          templateType: type,
          template:undefined,
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  return (
    <div className="w-full px-4 md:px-8 py-6">
      <Spin spinning={loading}>
        <Form form={form}>
          <Row className="" gutter={18}>
            <Col xs={24} md={6}>
              <Form.Item
                name="Company"
                label="Company"
                colon={false}
                layout="vertical"
              >
                <Select
                  style={{ minWidth: 250 }}
                  size="middle"
                  value={get(filter, "company.id")}
                  placeholder="Select Company"
                  optionFilterProp="label"
                  showSearch
                  options={companies}
                  onChange={(val) => {
                    setDataSource([]);
                    const company = find(get(config, "companies", []), [
                      "id",
                      val,
                    ]);
                    setSelectedShift(get(company, "company_shifts.0"));
                    setFilters({
                      ...filter,
                      templateType: undefined,
                      template: undefined,
                      company,
                    });

                    setConfig({
                      ...config,
                      template_types: get(company, "template_access_list"),
                    });

                    form.setFieldsValue({
                      template_type: undefined,
                      template: undefined,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item
                name="template_type"
                label="Template Type"
                colon={false}
                layout="vertical"
              >
                <Select
                  style={{ minWidth: 250 }}
                  size="middle"
                  placeholder="Type"
                  options={map(
                    get(config, "template_types", []),
                    (templateType) => ({
                      label: get(templateType, "name"),
                      value: get(templateType, "value"),
                    })
                  )}
                  value={get(filter, "templateType")}
                  onChange={(value) => {
                    getCompanyTemplates(value);
                    form.setFieldsValue({
                      template: undefined,
                    });
                    setDataSource([])
                  }}
                  disabled={isUndefined(get(filter, "company"))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item
                name="template"
                label="Template"
                colon={false}
                layout="vertical"
              >
                <Select
                  style={{ minWidth: 250 }}
                  size="middle"
                  placeholder="Select Machine"
                  options={map(get(config, "templates", []), (template) => ({
                    label: get(template, "name"),
                    value: get(template, "id"),
                  }))}
                  value={get(filter, "template")}
                  onChange={(value) => {
                    setFilters({
                      ...filter,
                      template: value,
                    });
                    setDataSource([])
                  }}
                  disabled={isNil(get(filter, "templateType"))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={4}>
              <Form.Item
                initialValue={get(filter, "date")}
                name="date"
                label="Date"
                colon={false}
                layout="vertical"
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  disabledDate={disabledDate}
                  onChange={(value) => {
                    setFilters(set({ ...filter }, "date", value));
                  }}
                  value={get(filter, "date")}
                  disabled={isNil(get(filter, "template"))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={2}>
              <Form.Item
                name="submit"
                label=" "
                colon={false}
                layout="vertical"
              >
                <Button
                  type="primary"
                  className="w-30"
                  onClick={getDetails}
                  disabled={getButtonDisabled(filter, [
                    "templateType",
                    "company",
                    "date",
                    "template",
                  ])}
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
};

export default HeaderSelector;
